var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResponsive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-1--inject-148"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-1--inject-148",
    cx: 249.99,
    cy: 328.15,
    rx: 236.58,
    ry: 136.59,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-1--inject-148"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-1--inject-148",
    d: "M241.8,255.52,366.32,327.4a4.41,4.41,0,0,0,4,0l90.48-52.24a1.22,1.22,0,0,0,0-2.32L336.32,201a4.41,4.41,0,0,0-4,0L241.8,253.19A1.23,1.23,0,0,0,241.8,255.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-1--inject-148",
    d: "M75.61,363.07,151,406.58a4.47,4.47,0,0,0,4,0l105.61-61a1.23,1.23,0,0,0,0-2.33l-75.37-43.51a4.47,4.47,0,0,0-4,0l-105.61,61A1.23,1.23,0,0,0,75.61,363.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-1--inject-148",
    d: "M179.87,412l48.9,28.23a4.41,4.41,0,0,0,4,0l92.09-53.16a1.23,1.23,0,0,0,0-2.33L276,356.52a4.47,4.47,0,0,0-4,0l-92.09,53.17A1.22,1.22,0,0,0,179.87,412Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-1--inject-148",
    d: "M55.34,319.08,26.23,302.27c-1.64-.94-1.64-2.48,0-3.43L203.11,196.71a6.55,6.55,0,0,1,5.94,0l29.11,16.8c1.64,1,1.64,2.49,0,3.44L61.28,319.08A6.61,6.61,0,0,1,55.34,319.08Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-1--inject-148"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-1--inject-148"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160,289.13l25-14.47c2.58-1.49,3.87-3.44,3.87-5.39s0-3.48,0-3.48l-26-14.64a5.5,5.5,0,0,1-2.49-4.31V216l-43.7,25.25v30.85a5.48,5.48,0,0,0,2.49,4.31l22.08,12.73C146.43,292.11,154.79,292.11,160,289.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.19,277.55V281l-8-4.62a5.5,5.5,0,0,1-2.48-4.31V241.25l8.32-4.81c.17,2.12.36,4.3.53,6.43l-5.83,3.38v24.1a5.47,5.47,0,0,0,2.48,4.31Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.71,270.35a5.54,5.54,0,0,0,2.49,4.32l19.07,11c5.16,3,13.52,3,18.68,0l25-14.46c5.16-3,5.16-7.81,0-10.79l-19.07-11a5.51,5.51,0,0,1-2.49-4.32V221l-43.71,25.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,252.35h0l-5.07-2.92a5.51,5.51,0,0,1-2.49-4.32V221l-43.71,25.25v24.1a5.54,5.54,0,0,0,2.49,4.32l5,2.88Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.85,265.79v3.48c0,2-1.3,3.9-3.87,5.39l-25,14.46a18.72,18.72,0,0,1-8.91,2.22v-3.47a18.72,18.72,0,0,0,8.91-2.21l25-14.47C187.55,269.7,188.85,267.75,188.85,265.79Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.28,56.12V192.85a6.88,6.88,0,0,1-3.1,5.39l-4.57,2.63-1.66,1-4.82,2.78L219,205.87,139.9,251.53l-3.66,2.11L113.46,266.8l-3.67,2.12-10.72,6.19-3.45,2-3.4,2L88.91,281l-4.84,2.79-4.65,2.68-31.8,18.38-.29.14s0,0-.08,0c-1.55.68-2.75-.15-2.75-2v2.59a5.94,5.94,0,0,1-2.92-.67,6.68,6.68,0,0,1-2.91-5.28V162.94a6.88,6.88,0,0,1,3.1-5.39L226.33,51a5.82,5.82,0,0,1,8.92,4.63A4.58,4.58,0,0,1,235.28,56.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.28,56.12V192.85a6.88,6.88,0,0,1-3.1,5.39l-4.57,2.63-1.66,1-4.82,2.78L219,205.87,139.9,251.53l-3.66,2.11L113.46,266.8l-3.67,2.12-10.72,6.19-3.45,2-3.4,2L88.91,281l-4.84,2.79-4.65,2.68-31.8,18.38-.29.14s0,0-.08,0c-1.55.68-2.75-.15-2.75-2V166.3a6.85,6.85,0,0,1,3.12-5.38L232.18,54.33c1.56-.91,2.84-.33,3.07,1.26A4.58,4.58,0,0,1,235.28,56.12Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5,303V293.9l-5.83-3.37v9.13a6.68,6.68,0,0,0,2.91,5.28,5.94,5.94,0,0,0,2.92.67,5.68,5.68,0,0,0,.72-.05,5.46,5.46,0,0,0,.69-.1l.06,0a4.75,4.75,0,0,0,.54-.14h0l.17-.05c.18-.07.36-.14.54-.23C45.7,305.69,44.5,304.86,44.5,303Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.28,183.69v9.16a6.88,6.88,0,0,1-3.1,5.39l-4.57,2.63-1.66,1-4.82,2.78L219,205.87,139.9,251.53l-3.66,2.11L113.46,266.8l-3.67,2.12-10.72,6.19-3.45,2-3.4,2L88.91,281l-4.84,2.79-4.65,2.68-31.8,18.38-.29.14s0,0-.08,0c-1.55.68-2.75-.15-2.75-2V293.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.42,163.23a6.52,6.52,0,0,0-.92,3.07V293.9l-5.84-3.38V162.94a6.45,6.45,0,0,1,.92-3.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.78,250.29a1.93,1.93,0,0,1-1-.27,2.5,2.5,0,0,1-1.11-2.32,6.9,6.9,0,0,1,3.17-5.49h0a2.26,2.26,0,0,1,3.67,2.12,6.91,6.91,0,0,1-3.17,5.49A3.17,3.17,0,0,1,138.78,250.29Zm1.55-7.22a6,6,0,0,0-2.67,4.63,1.3,1.3,0,0,0,2.17,1.25,6,6,0,0,0,2.67-4.62,1.3,1.3,0,0,0-2.17-1.26Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.34,278.28v-110A4.11,4.11,0,0,1,52.21,165L227.57,63.73c1-.6,1.87-.12,1.87,1.08v110a4.14,4.14,0,0,1-1.87,3.24L52.21,279.36C51.18,280,50.34,279.47,50.34,278.28Z",
    style: {
      fill: "#00A6C3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.58,166,218.12,74.46c1.11-.65,2-.13,2,1.16v100a4.46,4.46,0,0,1-2,3.49L59.58,270.65c-1.11.64-2,.12-2-1.16v-100A4.45,4.45,0,0,1,59.58,166Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.67,189.88a.5.5,0,0,1-.5-.5V123.5a.5.5,0,1,1,1,0v65.88A.5.5,0,0,1,193.67,189.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.47,118.81l14.87-8.58c1.11-.64,2-.12,2,1.16v17.18a4.48,4.48,0,0,1-2,3.49l-14.88,8.58c-1.11.65-2,.12-2-1.16V122.3A4.46,4.46,0,0,1,199.47,118.81Z",
    style: {
      fill: "#00A6C3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.47,118.81l14.87-8.58c1.11-.64,2-.12,2,1.16v17.18a4.48,4.48,0,0,1-2,3.49l-14.88,8.58c-1.11.65-2,.12-2-1.16V122.3A4.46,4.46,0,0,1,199.47,118.81Z",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213,122a.81.81,0,0,0-1.21.22l-2.66,4.61,2.17,3-7.07-6.49a.78.78,0,0,0-1.25.23l-5.5,11.3v4.52c0,1.28.9,1.81,2,1.16l14.88-8.58a4.48,4.48,0,0,0,2-3.49v-3.68Z",
    style: {
      fill: "#00A6C3",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210,116.43a4.17,4.17,0,0,0-1.89,3.27c0,1.21.85,1.69,1.89,1.09a4.19,4.19,0,0,0,1.89-3.27C211.87,116.31,211,115.82,210,116.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.46,144.44l16.89-9.75c.55-.32,1-.09,1,.51a2.17,2.17,0,0,1-1,1.67l-16.89,9.75c-.56.32-1,.09-1-.51A2.15,2.15,0,0,1,198.46,144.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.46,147.77,215.35,138c.55-.32,1-.09,1,.51a2.17,2.17,0,0,1-1,1.67L198.46,150c-.56.32-1,.09-1-.51A2.15,2.15,0,0,1,198.46,147.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.46,151.11l16.89-9.75c.55-.32,1-.1,1,.51a2.17,2.17,0,0,1-1,1.67l-16.89,9.75c-.56.32-1,.09-1-.51A2.15,2.15,0,0,1,198.46,151.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.47,156.18l14.87-8.58c1.11-.64,2-.12,2,1.16v17.18a4.48,4.48,0,0,1-2,3.49L199.46,178c-1.11.65-2,.12-2-1.16V159.67A4.46,4.46,0,0,1,199.47,156.18Z",
    style: {
      fill: "#00A6C3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.47,156.18l14.87-8.58c1.11-.64,2-.12,2,1.16v17.18a4.48,4.48,0,0,1-2,3.49L199.46,178c-1.11.65-2,.12-2-1.16V159.67A4.46,4.46,0,0,1,199.47,156.18Z",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213,159.41a.81.81,0,0,0-1.21.22l-2.66,4.61,2.17,3-7.07-6.49A.78.78,0,0,0,203,161l-5.5,11.29v4.52c0,1.28.9,1.81,2,1.16l14.88-8.58a4.48,4.48,0,0,0,2-3.49v-3.68Z",
    style: {
      fill: "#00A6C3",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210,153.8a4.17,4.17,0,0,0-1.89,3.27c0,1.21.85,1.69,1.89,1.09a4.19,4.19,0,0,0,1.89-3.27C211.87,153.68,211,153.19,210,153.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.46,181.81l16.89-9.75c.55-.32,1-.09,1,.51a2.17,2.17,0,0,1-1,1.67L198.46,184c-.56.32-1,.09-1-.51A2.15,2.15,0,0,1,198.46,181.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.46,185.14l16.89-9.75c.55-.32,1-.09,1,.51a2.17,2.17,0,0,1-1,1.67l-16.89,9.76c-.56.32-1,.09-1-.51A2.15,2.15,0,0,1,198.46,185.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.61,194.25,184.09,142c1.12-.64,2-.12,2,1.17v47.73a4.44,4.44,0,0,1-2,3.49L93.61,246.64c-1.12.64-2,.12-2-1.16V197.74A4.46,4.46,0,0,1,93.61,194.25Z",
    style: {
      fill: "#00A6C3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.61,194.25,184.09,142c1.12-.64,2-.12,2,1.17v47.73a4.44,4.44,0,0,1-2,3.49L93.61,246.64c-1.12.64-2,.12-2-1.16V197.74A4.46,4.46,0,0,1,93.61,194.25Z",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.08,170.12a10.84,10.84,0,0,0-4.9,8.48c0,3.13,2.2,4.39,4.9,2.83A10.81,10.81,0,0,0,157,173C157,169.82,154.79,168.55,152.08,170.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.61,246.64l90.48-52.24a4.44,4.44,0,0,0,2-3.49v-2.52L169.27,175.8a2.55,2.55,0,0,0-3.59.54L150.09,197.6l6.95,8.05-28.12-20.19a2.55,2.55,0,0,0-3.65.72L91.59,240.07v5.41C91.59,246.76,92.49,247.28,93.61,246.64Z",
    style: {
      fill: "#00A6C3",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.13,74.87v7.85L57.56,176.58v-7.85A3.24,3.24,0,0,1,59,166.19L218.67,74C219.48,73.55,220.13,73.93,220.13,74.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.13,82.72v9.55L57.56,186.13v-9.55l3-1.75c.81-.47,1.08-1.18,1.47-2.55l1-3.55a3.72,3.72,0,0,1,1.47-2.55l35-20.23c.82-.46,1.45-.52,2.07.51l1.26,2.28c.46.79.69,1.26,1.5.79Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.43,79.43c.87-.5,1.57-.09,1.57.9a3.46,3.46,0,0,1-1.57,2.72c-.86.5-1.56.09-1.56-.91A3.46,3.46,0,0,1,214.43,79.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.79,82.68c.87-.5,1.57-.09,1.57.91a3.45,3.45,0,0,1-1.57,2.71c-.86.5-1.57.1-1.57-.9A3.49,3.49,0,0,1,208.79,82.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.15,85.93c.87-.49,1.57-.09,1.57.91a3.45,3.45,0,0,1-1.57,2.71c-.87.5-1.57.1-1.57-.9A3.46,3.46,0,0,1,203.15,85.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3,177.27,62,178.6l.87-1.69a.42.42,0,0,0,0-.42c-.07-.08-.18,0-.26.13L61.38,179h0a.36.36,0,0,0,0,.09s0,0,0,0a.49.49,0,0,0,0,.12.34.34,0,0,0,0,.11s0,0,0,0a.1.1,0,0,0,0,0h0l1.25,1a.09.09,0,0,0,.12,0,.31.31,0,0,0,.14-.17c.07-.16.06-.34,0-.4l-.87-.67,2.3-1.33a.51.51,0,0,0,.19-.4C64.49,177.29,64.4,177.21,64.3,177.27Z",
    style: {
      fill: "#455a64",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.23,176.15l2.3-1.33-.88-.67a.39.39,0,0,1,0-.4c.06-.15.18-.23.26-.17l1.25,1h0a.1.1,0,0,1,0,.05v0a.34.34,0,0,1,0,.11.49.49,0,0,1,0,.12,0,0,0,0,0,0,0,.36.36,0,0,1,0,.09h0l-1.25,2.4a.35.35,0,0,1-.12.14c-.06,0-.11,0-.14,0a.44.44,0,0,1,0-.42l.88-1.69-2.3,1.33c-.11.06-.19,0-.19-.17A.48.48,0,0,1,66.23,176.15Z",
    style: {
      fill: "#455a64",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.79,169.51c0-.14-.13-.12-.2,0l-.31.78c-.54-.06-1.19.46-1.63,1.4-.57,1.21-.57,2.64,0,3.18a.81.81,0,0,0,1,.07,2.88,2.88,0,0,0,1-1.26.4.4,0,0,0,0-.4c-.07-.07-.19,0-.26.15-.43.9-1.12,1.3-1.55.89a2.31,2.31,0,0,1,0-2.38c.3-.64.74-1,1.12-1.05l-.24.58c-.06.16,0,.3.09.23l.94-.61a.29.29,0,0,0,.11-.26Z",
    style: {
      fill: "#455a64",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.57,150.31l.84-1.78a.53.53,0,0,0,0-.55c-.1-.1-.26,0-.36.21L98.21,150l-.84-.81c-.1-.1-.26,0-.36.21a.53.53,0,0,0,0,.55l.84.81L97,152.51a.53.53,0,0,0,0,.55.14.14,0,0,0,.18,0,.46.46,0,0,0,.18-.22l.84-1.78.84.81a.14.14,0,0,0,.18,0,.43.43,0,0,0,.18-.21.55.55,0,0,0,0-.56Z",
    style: {
      fill: "#455a64",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.85,171.7v-3a3.23,3.23,0,0,1,1.47-2.54L210.4,90c.81-.47,1.47-.09,1.47.85v3a3.26,3.26,0,0,1-1.47,2.54L78.32,172.55C77.51,173,76.85,172.64,76.85,171.7Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.4,96.68a.57.57,0,0,1-.18,0,.53.53,0,0,1-.29-.57l.14-1.14-.51-.37a.5.5,0,0,1-.21-.42.81.81,0,0,1,.29-.61l.86-.67.39-1.27a.63.63,0,0,1,.54-.49.45.45,0,0,1,.45.27h0l.28.59.62-.24a.46.46,0,0,1,.53.12.66.66,0,0,1,0,.73l-.62,1.17.14,1.06a.79.79,0,0,1-.22.63.55.55,0,0,1-.44.17l-.64-.08-.72.92A.57.57,0,0,1,208.4,96.68Zm-.24-2.6.46.34a.53.53,0,0,1,.2.51l0,.38L209,95a.55.55,0,0,1,.5-.23l.57.07-.12-1a.73.73,0,0,1,.09-.45l.39-.74-.26.1a.47.47,0,0,1-.6-.24l-.12-.26-.25.83a.79.79,0,0,1-.26.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.73,89.65a.48.48,0,0,1-.24-.89l3.88-2.24a.48.48,0,0,1,.65.17.49.49,0,0,1-.18.66L214,89.58A.44.44,0,0,1,213.73,89.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.73,91.89a.48.48,0,0,1-.24-.89l3.88-2.24a.47.47,0,1,1,.47.82L214,91.82A.44.44,0,0,1,213.73,91.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.73,94.13a.48.48,0,0,1-.24-.89L217.37,91a.46.46,0,0,1,.65.17.48.48,0,0,1-.18.65L214,94.06A.55.55,0,0,1,213.73,94.13Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M67,186.47l12.41-7.17c.46-.26.83-.05.83.48v1.08a1.84,1.84,0,0,1-.83,1.44L67,189.47c-.46.26-.83.05-.83-.48v-1.08A1.87,1.87,0,0,1,67,186.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.59,189.41v1.08a1.81,1.81,0,0,1-.83,1.43l-.93.54c-.46.27-.83,0-.83-.48V190.9a1.82,1.82,0,0,1,.83-1.43l.93-.54C63.22,188.66,63.59,188.88,63.59,189.41Z",
    style: {
      fill: "#00A6C3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,192.44l12.41-7.17c.46-.27.83-.05.83.48v1.08a1.81,1.81,0,0,1-.83,1.43L67,195.43c-.46.27-.83,0-.83-.47v-1.08A1.85,1.85,0,0,1,67,192.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.59,195.37v1.08a1.83,1.83,0,0,1-.83,1.44l-.93.54c-.46.26-.83,0-.83-.48v-1.08a1.84,1.84,0,0,1,.83-1.44l.93-.53C63.22,194.63,63.59,194.84,63.59,195.37Z",
    style: {
      fill: "#00A6C3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,198.41l12.41-7.17c.46-.27.83-.05.83.47v1.08a1.83,1.83,0,0,1-.83,1.44L67,201.4c-.46.27-.83,0-.83-.48v-1.08A1.84,1.84,0,0,1,67,198.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.59,201.34v1.08a1.84,1.84,0,0,1-.83,1.44l-.93.54c-.46.26-.83,0-.83-.48v-1.08a1.84,1.84,0,0,1,.83-1.44l.93-.54C63.22,200.6,63.59,200.81,63.59,201.34Z",
    style: {
      fill: "#00A6C3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,204.28l12.41-7.17c.46-.26.83-.05.83.48v1.08a1.81,1.81,0,0,1-.83,1.43L67,207.28c-.46.26-.83.05-.83-.48v-1.08A1.87,1.87,0,0,1,67,204.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.59,207.21v1.08a1.83,1.83,0,0,1-.83,1.44l-.93.54c-.46.26-.83,0-.83-.48v-1.08a1.81,1.81,0,0,1,.83-1.43l.93-.54C63.22,206.47,63.59,206.69,63.59,207.21Z",
    style: {
      fill: "#00A6C3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,209.91l12.41-7.17c.46-.26.83-.05.83.48v1.08a1.84,1.84,0,0,1-.83,1.44L67,212.91c-.46.26-.83.05-.83-.48v-1.08A1.87,1.87,0,0,1,67,209.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.59,212.85v1.08a1.81,1.81,0,0,1-.83,1.43l-.93.54c-.46.27-.83,0-.83-.48v-1.08a1.82,1.82,0,0,1,.83-1.43l.93-.54C63.22,212.1,63.59,212.32,63.59,212.85Z",
    style: {
      fill: "#00A6C3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84,253.11a.5.5,0,0,1-.5-.5V173.7a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v78.91A.5.5,0,0,1,84,253.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.17,178.37a10.14,10.14,0,0,0-4.58,7.94c0,2.92,2,4.11,4.58,2.65a10.16,10.16,0,0,0,4.59-7.94C100.75,178.09,98.7,176.91,96.17,178.37Z",
    style: {
      fill: "#00A6C3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.64,183a.83.83,0,0,1-.41-.1,1,1,0,0,1-.44-.92A2.63,2.63,0,0,1,96,179.92h0a.9.9,0,0,1,1.45.84,2.64,2.64,0,0,1-1.2,2.09A1.25,1.25,0,0,1,95.64,183Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98,183.34a1.58,1.58,0,0,0-1.61.12l-.67.38a4.52,4.52,0,0,0-2.06,3.58v.47a2.56,2.56,0,0,0,2.53-.27A7.34,7.34,0,0,0,98.7,185v-.11A1.65,1.65,0,0,0,98,183.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,177.24c0,1.2.91,1.66,2,1l18.65-10.77a4.32,4.32,0,0,0,2-3.35c0-1.21-.9-1.66-2-1L106,173.89A4.33,4.33,0,0,0,104,177.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,182.8c0,.62.47.86,1,.53l9.7-5.6a2.27,2.27,0,0,0,1-1.74c0-.63-.47-.87-1-.53l-9.7,5.6A2.23,2.23,0,0,0,104,182.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.55 171.11 83.55 182.6 220.13 103.74 220.13 92.27 83.55 171.11",
    style: {
      fill: "#00A6C3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.55 171.11 83.55 182.6 220.13 103.74 220.13 92.27 83.55 171.11",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6,169l71.59-41.33c1.11-.64,2-.18,2,1a4.32,4.32,0,0,1-2,3.35L93.61,173.37c-1.12.64-2,.18-2-1A4.32,4.32,0,0,1,93.6,169Z",
    style: {
      fill: "#fafafa"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tablet--inject-1--inject-148"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--tablet--inject-1--inject-148"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--device--inject-1--inject-148"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.23,353.86l67.4,38.86a3.47,3.47,0,0,0,3.14,0l102.45-59.14a1,1,0,0,0,0-1.81l-67.4-38.87a3.51,3.51,0,0,0-3.14,0L80.23,352.05A1,1,0,0,0,80.23,353.86Zm95.33-53.41a2.18,2.18,0,0,1,2.26.25l62.73,36.2a.82.82,0,0,1,0,1.55l-81.47,47a3,3,0,0,1-2.7,0l-62.73-36.2a.82.82,0,0,1,0-1.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.39,373.6a6.36,6.36,0,0,1-3.11-.75,2.49,2.49,0,0,1-1.44-2.09,2.47,2.47,0,0,1,1.44-2.08,6.76,6.76,0,0,1,6.22,0,2.47,2.47,0,0,1,1.44,2.08,2.49,2.49,0,0,1-1.44,2.09A6.36,6.36,0,0,1,119.39,373.6Zm0-4.67a5.35,5.35,0,0,0-2.61.61c-.6.35-.94.78-.94,1.22s.34.87.94,1.22a5.85,5.85,0,0,0,5.22,0c.61-.35.94-.78.94-1.22s-.33-.87-.94-1.22A5.33,5.33,0,0,0,119.39,368.93Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.4,331.89a3.49,3.49,0,0,1,1.39,2.6v3.93a3.48,3.48,0,0,1-1.57,2.73L150.77,400.29a3,3,0,0,1-1.15.35c-.14,0-.27,0-.42,0h0V393.1h0a4.46,4.46,0,0,0,.63,0,2.82,2.82,0,0,0,.94-.32l102.45-59.15C254,333.11,254.08,332.39,253.4,331.89Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.56,300.45a2.18,2.18,0,0,1,2.26.25l62.73,36.2a.82.82,0,0,1,0,1.55l-81.47,47a3,3,0,0,1-2.7,0l-62.73-36.2a.82.82,0,0,1,0-1.55Z",
    style: {
      fill: "#00A6C3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.56,300.45a2.18,2.18,0,0,1,2.26.25l62.73,36.2a.82.82,0,0,1,0,1.55l-81.47,47a3,3,0,0,1-2.7,0l-62.73-36.2a.82.82,0,0,1,0-1.55Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.52,309.32l-63.77,36.82c-2.22,1.29-2.22,3.37,0,4.65l44.87,25.91a8.88,8.88,0,0,0,8.06,0l63.77-36.82c2.22-1.28,2.22-3.37,0-4.65l-44.87-25.91A8.94,8.94,0,0,0,172.52,309.32Z",
    style: {
      fill: "#00A6C3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.05,363.37a9.25,9.25,0,0,1-4.5-1.09l-22.19-12.81a3.37,3.37,0,0,1,0-6.27l37.31-21.54a9.83,9.83,0,0,1,9,0l22.19,12.81a3.37,3.37,0,0,1,0,6.27l-37.31,21.54A9.24,9.24,0,0,1,161.05,363.37Zm15.12-40.93a7.44,7.44,0,0,0-3.57.83l-37.3,21.54c-.77.44-1.21,1-1.21,1.52s.44,1.08,1.21,1.52l22.18,12.81a8,8,0,0,0,7.13,0l37.31-21.54c.76-.44,1.2-1,1.2-1.52s-.44-1.08-1.2-1.52l-22.19-12.81A7.37,7.37,0,0,0,176.17,322.44Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.5,343.13l11.09,6.41a2.68,2.68,0,0,0,3.4-.71l8.57-11.54c.77-1,.38-1.62-.87-1.31l-21.95,5.43C154.5,341.72,154.39,342.49,155.5,343.13Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,352.19c-.65.5-.58,1.22.21,1.67l67.4,38.86a3.2,3.2,0,0,0,1.57.38v7.56a3.1,3.1,0,0,1-1.57-.38l-67.4-38.85a3.49,3.49,0,0,1-1.57-2.72v-3.94A3.5,3.5,0,0,1,80,352.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.77,315.16a1.06,1.06,0,0,0,.95,0,.29.29,0,0,0,0-.55,1.06,1.06,0,0,0-.95,0A.29.29,0,0,0,215.77,315.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.29,319.48a2.14,2.14,0,0,0,1.91,0,.58.58,0,0,0,0-1.1,2.08,2.08,0,0,0-1.91,0A.58.58,0,0,0,217.29,319.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216,317.56c.35-.2.33-.54,0-.76l-6.27-3.61a1.44,1.44,0,0,0-1.31,0c-.35.21-.33.54,0,.76l6.27,3.62A1.47,1.47,0,0,0,216,317.56Z",
    style: {
      fill: "#263238"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mobile--inject-1--inject-148"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--mobile--inject-1--inject-148"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--device--inject-1--inject-148"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.14,402.27c-.69.53-.61,1.29.22,1.76l45.53,26.29a3.64,3.64,0,0,0,3.31,0l87-50.24c.84-.48.91-1.25.19-1.78a3.71,3.71,0,0,1,1.46,2.74v2.19a3.61,3.61,0,0,1-1.65,2.87l-87,50.24a3.66,3.66,0,0,1-3.32,0l-45.53-26.29a3.65,3.65,0,0,1-1.65-2.87V405A3.7,3.7,0,0,1,183.14,402.27Z",
    style: {
      fill: "#00A6C3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.14,402.27c-.69.53-.61,1.29.22,1.76l45.53,26.29a3.64,3.64,0,0,0,3.31,0l87-50.24c.84-.48.91-1.25.19-1.78a3.71,3.71,0,0,1,1.46,2.74v2.19a3.61,3.61,0,0,1-1.65,2.87l-87,50.24a3.66,3.66,0,0,1-3.32,0l-45.53-26.29a3.65,3.65,0,0,1-1.65-2.87V405A3.7,3.7,0,0,1,183.14,402.27Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.36,404l45.53,26.29a3.64,3.64,0,0,0,3.31,0l87-50.24a1,1,0,0,0,0-1.9l-45.53-26.3a3.7,3.7,0,0,0-3.32,0l-87,50.23C182.45,402.65,182.44,403.51,183.36,404Zm80-45.35a2.28,2.28,0,0,1,2.38.27l41.4,23.9a.87.87,0,0,1,0,1.64L239.4,423.6a3.13,3.13,0,0,1-2.84,0l-41.39-23.9a.87.87,0,0,1,0-1.64Z",
    style: {
      fill: "#00A6C3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.36,404l45.53,26.29a3.64,3.64,0,0,0,3.31,0l87-50.24a1,1,0,0,0,0-1.9l-45.53-26.3a3.7,3.7,0,0,0-3.32,0l-87,50.23C182.45,402.65,182.44,403.51,183.36,404Zm80-45.35a2.28,2.28,0,0,1,2.38.27l41.4,23.9a.87.87,0,0,1,0,1.64L239.4,423.6a3.13,3.13,0,0,1-2.84,0l-41.39-23.9a.87.87,0,0,1,0-1.64Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.41,378.3a3.71,3.71,0,0,1,1.46,2.74v2.19a3.64,3.64,0,0,1-1.65,2.87l-87,50.24a3.57,3.57,0,0,1-1.66.4v-6a3.29,3.29,0,0,0,1.66-.4l87-50.24C320.06,379.6,320.13,378.83,319.41,378.3Z",
    style: {
      fill: "#00A6C3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.41,378.3a3.71,3.71,0,0,1,1.46,2.74v2.19a3.64,3.64,0,0,1-1.65,2.87l-87,50.24a3.57,3.57,0,0,1-1.66.4v-6a3.29,3.29,0,0,0,1.66-.4l87-50.24C320.06,379.6,320.13,378.83,319.41,378.3Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M292.08,367.61a.68.68,0,0,1,0-1.28,2.48,2.48,0,0,1,2.22,0,.67.67,0,0,1,0,1.28A2.42,2.42,0,0,1,292.08,367.61Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M210.43,416.82a5.92,5.92,0,0,1-2.87-.7,2.31,2.31,0,0,1-1.33-1.94,2.29,2.29,0,0,1,1.33-1.94,6.23,6.23,0,0,1,5.73,0,2.29,2.29,0,0,1,1.33,1.94,2.31,2.31,0,0,1-1.33,1.94A5.85,5.85,0,0,1,210.43,416.82Zm0-4.27a4.85,4.85,0,0,0-2.37.55,1.4,1.4,0,0,0-.83,1.08,1.37,1.37,0,0,0,.83,1.07,5.32,5.32,0,0,0,4.73,0,1.37,1.37,0,0,0,.83-1.07,1.4,1.4,0,0,0-.83-1.08A4.84,4.84,0,0,0,210.43,412.55Z",
    style: {
      fill: "#e6e6e6"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M293.18,371.86l-8.57-4.94c-.51-.3-.54-.76-.06-1a2,2,0,0,1,1.8,0l8.57,4.95c.51.3.53.76.05,1A2,2,0,0,1,293.18,371.86Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M263.37,358.68a2.28,2.28,0,0,1,2.38.27l41.4,23.9a.87.87,0,0,1,0,1.64L239.4,423.6a3.13,3.13,0,0,1-2.84,0l-41.39-23.9a.87.87,0,0,1,0-1.64Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M262.6,362.11l.44-.25a.34.34,0,0,1,.34,0l.05,0c.1.05.1.14,0,.2l-.44.25a.34.34,0,0,1-.34,0l0,0C262.5,362.26,262.5,362.17,262.6,362.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.38,362.57l.77-.44a.34.34,0,0,1,.34,0l.05,0a.1.1,0,0,1,0,.19l-.76.44a.36.36,0,0,1-.35,0l-.05,0C263.29,362.71,263.29,362.62,263.38,362.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.17,363l1.08-.62a.36.36,0,0,1,.35,0l0,0c.09.06.09.15,0,.2l-1.09.63a.4.4,0,0,1-.34,0l-.05,0C264.08,363.17,264.08,363.08,264.17,363Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265,363.48l1.87-1.08a.34.34,0,0,1,.34,0l.05,0c.1.06.1.15,0,.2l-1.87,1.08a.36.36,0,0,1-.35,0l0,0C264.86,363.62,264.86,363.53,265,363.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267,364.78s0,0,0,0l.27-.16-.88-.51c-.05,0-.05-.05,0-.07l.09-.06.06,0h.08l1.92,0h.08l.07,0,.12.08s.06,0,.06,0a.07.07,0,0,1,0,.06l-1,.55.2.11s.05,0,.05.06,0,0,0,.05l-.07,0a.12.12,0,0,1-.08,0l-.1,0-.19-.11-.28.15-.08,0-.1,0-.15-.08S267,364.8,267,364.78Zm.6-.31.69-.4-1.33,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.17,365.29c0-.19.1-.36.38-.52a1.53,1.53,0,0,1,.89-.21,2,2,0,0,1,.95.29,2.21,2.21,0,0,1,.32.22.67.67,0,0,1,.18.22,0,0,0,0,1,0,0h0l-.2,0h-.06s0,0,0,0a1,1,0,0,0-.36-.32,1.43,1.43,0,0,0-.65-.19,1.16,1.16,0,0,0-.65.16c-.22.13-.32.25-.3.38s.12.25.33.36a1,1,0,0,0,.23.12.7.7,0,0,0,.22.07l.44-.25-.37-.21s-.05,0-.05-.06,0,0,0-.05l.06,0a.15.15,0,0,1,.09,0l.1,0,.58.34a.1.1,0,0,1,.06.07s0,0-.05.06l-.63.36-.07,0h-.06a2.58,2.58,0,0,1-.84-.32C268.36,365.65,268.2,365.47,268.17,365.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.05,372.35l-1,.6a.08.08,0,0,0,0,.16l1,.61a.34.34,0,0,0,.28,0l1-.61c.08,0,.08-.11,0-.16l-1-.6A.28.28,0,0,0,283.05,372.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.46,372.76a.28.28,0,0,0,0-.51.76.76,0,0,0-.72,0l-.36.21.09.15.36-.21a.64.64,0,0,1,.54,0c.05,0,.09.07.09.11s0,.07-.09.1l-.36.21.09.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.45,383.71a.35.35,0,0,0-.2-.29l-2.64-1.52a.89.89,0,0,0-.81,0l-1,.55a.36.36,0,0,0-.19.29.4.4,0,0,0,0,.15.56.56,0,0,0,.16.14l2.64,1.53a.89.89,0,0,0,.81,0l1-.56A.33.33,0,0,0,303.45,383.71Zm-4.61-1s0-.08.1-.12l1-.55a.68.68,0,0,1,.62,0l2.64,1.52a.15.15,0,0,1,.08.08l0,0c0,.05,0,.09-.1.13l-1,.55a.68.68,0,0,1-.62,0l-2.64-1.52C298.87,382.83,298.84,382.79,298.84,382.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.16,382.79l0,0,.86-.5a.53.53,0,0,1,.46,0l2.38,1.37s0,0,0,0l0,0-.87.5a.53.53,0,0,1-.46,0l-2.37-1.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.38,384.08c.1.06,0,.2-.18.31l-.18.1a.66.66,0,0,1-.54.11l-.19-.1.91-.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.39,375.36a1.63,1.63,0,0,0,.89,1.07,4.29,4.29,0,0,0,4.39-.2,6,6,0,0,1-2.62-.65c-1.46-.85-1.84-1.81-.5-2.59a5.19,5.19,0,0,1,4.8.35c1.67,1,2.13,2.34,0,3.59a6.9,6.9,0,0,1-6.9.1,2.86,2.86,0,0,1-1.56-1.74Zm6.08.36c1-.74.84-1.38,0-1.86a2.56,2.56,0,0,0-2.49,0c-.76.44-.65.95.21,1.45A4.33,4.33,0,0,0,264.47,375.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.29,377.5c.56.33.66.77.21,1a2,2,0,0,1-1.79-.12c-.56-.33-.67-.78-.22-1A2,2,0,0,1,269.29,377.5Zm-3.46,2c.57.32.67.76.21,1a2,2,0,0,1-1.78-.12c-.57-.33-.68-.78-.23-1A1.94,1.94,0,0,1,265.83,379.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270,379.84a6.07,6.07,0,0,1,6.21-.23c1.78,1,1.77,2.34-.4,3.59a6.21,6.21,0,0,1-6.27.26C267.77,382.44,267.83,381.09,270,379.84Zm4.33,2.5c1.82-1,1.81-1.72,1-2.2s-2-.5-3.82.55-1.85,1.77-1,2.25S272.52,383.39,274.34,382.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.92,383.83a6.07,6.07,0,0,1,6.21-.23c1.78,1,1.77,2.34-.39,3.59a6.23,6.23,0,0,1-6.28.26C274.68,386.43,274.74,385.08,276.92,383.83Zm4.33,2.5c1.82-1.05,1.81-1.72,1-2.2s-2-.5-3.82.55-1.85,1.77-1,2.25S279.43,387.38,281.25,386.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.59,377.4l34.77,20.07c.74.43.74,1.12,0,1.54l-8.88,5.13a2.92,2.92,0,0,1-2.67,0L230,384.07a.82.82,0,0,1,0-1.54l8.89-5.13A2.9,2.9,0,0,1,241.59,377.4Z",
    style: {
      fill: "#00A6C3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254,387.21,263,392.4c.41.23.42.61,0,.83a1.58,1.58,0,0,1-1.45,0L252.58,388c-.4-.24-.42-.61,0-.84A1.58,1.58,0,0,1,254,387.21Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.23,388.8l18.23,10.52c.41.24.42.61,0,.83a1.59,1.59,0,0,1-1.44,0l-18.23-10.52c-.41-.23-.42-.61,0-.83A1.59,1.59,0,0,1,251.23,388.8Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.47,390.4l18.23,10.52c.4.23.42.61,0,.83a1.58,1.58,0,0,1-1.45,0l-18.22-10.51c-.41-.24-.43-.61,0-.84A1.64,1.64,0,0,1,248.47,390.4Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.67,382.15c1.15.67,1.28.75,1.71,1a2.22,2.22,0,0,1,.65.55.7.7,0,0,1,0,.94,2.39,2.39,0,0,1-.65.55c-.43.27-.56.35-1.71,1s-1.29.74-1.76,1a4.64,4.64,0,0,1-.95.38,3,3,0,0,1-.81.1,3.18,3.18,0,0,1-.82-.1,4.4,4.4,0,0,1-.94-.38c-.48-.25-.62-.32-1.77-1s-1.28-.74-1.71-1a2.39,2.39,0,0,1-.65-.55.73.73,0,0,1,0-.94,2.22,2.22,0,0,1,.65-.55c.43-.27.57-.35,1.71-1s1.29-.73,1.77-1a3.91,3.91,0,0,1,.94-.38,3.18,3.18,0,0,1,.82-.1,3,3,0,0,1,.81.1,4.11,4.11,0,0,1,.95.38c.47.25.61.32,1.76,1m.78-.44c-1.17-.68-1.32-.76-1.8-1a6,6,0,0,0-1.24-.49,5,5,0,0,0-1.26-.15,4.89,4.89,0,0,0-1.26.15,5.75,5.75,0,0,0-1.24.49c-.48.25-.63.33-1.8,1s-1.31.76-1.75,1a3.06,3.06,0,0,0-.84.71,1.18,1.18,0,0,0-.27.73,1.13,1.13,0,0,0,.27.72,3.06,3.06,0,0,0,.84.72c.44.28.58.37,1.75,1s1.32.76,1.8,1a5.75,5.75,0,0,0,1.24.49,4.89,4.89,0,0,0,1.26.15,5,5,0,0,0,1.26-.15,6,6,0,0,0,1.24-.49c.48-.25.63-.34,1.8-1s1.31-.76,1.74-1a3,3,0,0,0,.85-.72,1.12,1.12,0,0,0,.26-.72,1.16,1.16,0,0,0-.26-.73,3,3,0,0,0-.85-.71c-.43-.28-.58-.37-1.74-1",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.36,382.91a4.91,4.91,0,0,0-4.42,0,1.35,1.35,0,0,0,0,2.55,4.85,4.85,0,0,0,4.42,0,1.35,1.35,0,0,0,0-2.55M240.72,385a.87.87,0,0,1,0-1.66,3.2,3.2,0,0,1,2.86,0,.88.88,0,0,1,0,1.66,3.2,3.2,0,0,1-2.86,0",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.25,384.49a1.17,1.17,0,0,1-1,0,.32.32,0,0,1,0-.6,1.17,1.17,0,0,1,1,0c.29.17.29.43,0,.6",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.32,387.58l34.77,20.08a.82.82,0,0,1,0,1.54l-8.89,5.13a3,3,0,0,1-2.66,0l-34.77-20.08a.8.8,0,0,1,0-1.53l8.89-5.14A3,3,0,0,1,224.32,387.58Z",
    style: {
      fill: "#00A6C3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.72,397.4l8.95,5.18c.41.24.43.61,0,.84a1.61,1.61,0,0,1-1.45,0l-8.95-5.19c-.41-.23-.42-.61,0-.83A1.56,1.56,0,0,1,236.72,397.4Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234,399l18.23,10.52c.4.23.42.61,0,.83a1.58,1.58,0,0,1-1.45,0l-18.22-10.51c-.41-.24-.43-.61,0-.84A1.64,1.64,0,0,1,234,399Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.2,400.59l18.22,10.51c.41.24.42.61,0,.84a1.62,1.62,0,0,1-1.44,0L229.78,401.4c-.41-.23-.42-.61,0-.83A1.58,1.58,0,0,1,231.2,400.59Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.88,396.06l1.32.76,3.81-2.19.91.53,1.38-.68-1-.59.73-.42c.3-.17.47-.21.72-.06l.71.41,1.32-.77-.91-.52a2.66,2.66,0,0,0-2.87,0l-1,.59-.68-.39-1.29.74.68.4Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Laptop--inject-1--inject-148"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--laptop--inject-1--inject-148"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M443.31,278.79a6.7,6.7,0,0,1-3.12,5.17L372.41,323.1a6.88,6.88,0,0,1-6.22,0L246.83,254.19a5.85,5.85,0,0,1,0-10.34l67.78-39.14a6.91,6.91,0,0,1,6.23,0l119.35,68.91A6.68,6.68,0,0,1,443.31,278.79Z",
    style: {
      fill: "#00A6C3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.72,249a6.69,6.69,0,0,0,3.11,5.17L366.19,323.1a6.41,6.41,0,0,0,3.11.74V317.1a6.31,6.31,0,0,1-3.11-.75l-119.36-68.9c-1.51-.87-1.69-2.22-.56-3.2A6.66,6.66,0,0,0,243.72,249Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.19,277.21l-67.78,39.14a6.82,6.82,0,0,1-6.22,0L246.83,247.44c-1.72-1-1.72-2.6,0-3.59l67.78-39.14a6.91,6.91,0,0,1,6.23,0l119.35,68.91C441.91,274.61,441.91,276.22,440.19,277.21Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.3,317.1v6.74a6.28,6.28,0,0,0,3.11-.74L440.19,284a5.83,5.83,0,0,0,.32-10.14c1.4,1,1.29,2.47-.32,3.39l-67.78,39.15A6.38,6.38,0,0,1,369.3,317.1Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.23,273.73c1.61-.93,1.52-2.5,1.52-4.49V175.62a6.86,6.86,0,0,0-3.11-5.39L325.29,101.32a6.64,6.64,0,0,0-6-.11c-1.61.93-1.52,2.5-1.52,4.48v93.63a6.88,6.88,0,0,0,3.11,5.39l119.35,68.91A6.7,6.7,0,0,0,446.23,273.73Z",
    style: {
      fill: "#00A6C3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.72,105.69c0-2,1.4-2.78,3.12-1.8L440.2,172.81a6.29,6.29,0,0,1,2.19,2.32l4.45-2.58h0a6.35,6.35,0,0,0-2.2-2.33l-119.35-68.9a6.67,6.67,0,0,0-6-.12C317.64,102.14,317.72,103.71,317.72,105.69Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.31,178.2v93.62c0,2-1.4,2.79-3.12,1.8L320.84,204.71a6.88,6.88,0,0,1-3.11-5.39V105.69c0-2,1.39-2.79,3.11-1.79l119.35,68.91A6.87,6.87,0,0,1,443.31,178.2Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.56,273.81a6.72,6.72,0,0,0,5.67-.08c1.61-.93,1.52-2.5,1.52-4.49V175.62a6.26,6.26,0,0,0-.91-3.07l-4.45,2.58h0a6.41,6.41,0,0,1,.92,3.07v93.62C443.31,273.66,442.11,274.49,440.56,273.81Z",
    style: {
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.52,176.4,323.45,110c-1-.6-1.87-.12-1.87,1.08v81.72a4.13,4.13,0,0,0,1.87,3.24l115.07,66.42c1,.59,1.87.11,1.87-1.08V179.63A4.12,4.12,0,0,0,438.52,176.4Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.47,117.18l107,61.8a4.16,4.16,0,0,1,1.58,3.34V254c0,1.35-.71,2-1.58,1.52l-107-61.79a4.2,4.2,0,0,1-1.58-3.35V118.7C325.88,117.36,326.59,116.68,327.47,117.18Z",
    style: {
      fill: "#00A6C3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.52,144.86v5a3.58,3.58,0,0,0,1.61,2.8L431,209.74c.89.51,1.62.09,1.62-.93v-5A3.56,3.56,0,0,0,431,201l-98.83-57.06C331.24,143.41,330.52,143.83,330.52,144.86Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332,154.81l9.58,5.54a3.44,3.44,0,0,1,1.3,2.75v14.77c0,1.1-.58,1.66-1.3,1.25L332,173.58a3.46,3.46,0,0,1-1.29-2.75V156.06C330.73,155,331.31,154.4,332,154.81Z",
    style: {
      fill: "#00A6C3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332,154.81l9.58,5.54a3.44,3.44,0,0,1,1.3,2.75v14.77c0,1.1-.58,1.66-1.3,1.25L332,173.58a3.46,3.46,0,0,1-1.29-2.75V156.06C330.73,155,331.31,154.4,332,154.81Z",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.73,169.32c-.24-.61-.62-1-.78-.87L338.36,170l1.28,4.64-4.56-11.73c-.25-.65-.66-1.09-.81-.88L330.73,167v3.88a3.46,3.46,0,0,0,1.29,2.75l9.59,5.54c.72.41,1.3-.15,1.3-1.25v-3.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.8,161.89c-.67-.39-1.21.14-1.21,1.18a3.23,3.23,0,0,0,1.21,2.58c.68.38,1.22-.14,1.22-1.18A3.21,3.21,0,0,0,338.8,161.89Z",
    style: {
      fill: "#00A6C3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332,175.32l9.58,5.53a3.44,3.44,0,0,1,1.3,2.75v14.77c0,1.1-.58,1.66-1.3,1.25L332,194.08a3.44,3.44,0,0,1-1.29-2.75V176.57C330.73,175.46,331.31,174.9,332,175.32Z",
    style: {
      fill: "#00A6C3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332,175.32l9.58,5.53a3.44,3.44,0,0,1,1.3,2.75v14.77c0,1.1-.58,1.66-1.3,1.25L332,194.08a3.44,3.44,0,0,1-1.29-2.75V176.57C330.73,175.46,331.31,174.9,332,175.32Z",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.73,189.82c-.24-.6-.62-1-.78-.87l-1.59,1.54,1.28,4.63-4.56-11.72c-.25-.66-.66-1.1-.81-.89l-3.54,4.94v3.88a3.44,3.44,0,0,0,1.29,2.75l9.59,5.54c.72.41,1.3-.15,1.3-1.25v-3.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.8,182.4c-.67-.39-1.21.13-1.21,1.17a3.23,3.23,0,0,0,1.21,2.58c.68.39,1.22-.14,1.22-1.17A3.18,3.18,0,0,0,338.8,182.4Z",
    style: {
      fill: "#00A6C3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.66,164.68l84.94,49a2.21,2.21,0,0,1,1,1.71c0,.62-.45.86-1,.54l-84.94-49a2.19,2.19,0,0,1-1-1.71C345.65,164.6,346.1,164.36,346.66,164.68Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.66,169.06l84.94,49a2.19,2.19,0,0,1,1,1.7c0,.62-.45.87-1,.54l-84.94-49a2.17,2.17,0,0,1-1-1.7C345.65,169,346.1,168.74,346.66,169.06Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.66,173.43l84.94,49a2.22,2.22,0,0,1,1,1.71c0,.62-.45.86-1,.54l-84.94-49a2.17,2.17,0,0,1-1-1.7C345.65,173.35,346.1,173.11,346.66,173.43Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.66,177.81l84.94,49a2.19,2.19,0,0,1,1,1.7c0,.62-.45.87-1,.55l-84.94-49a2.21,2.21,0,0,1-1-1.71C345.65,177.73,346.1,177.49,346.66,177.81Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.66,185.07l84.94,49a2.22,2.22,0,0,1,1,1.71c0,.62-.45.86-1,.54l-84.94-49a2.17,2.17,0,0,1-1-1.7C345.65,185,346.1,184.75,346.66,185.07Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.66,189.45l84.94,49a2.19,2.19,0,0,1,1,1.7c0,.63-.45.87-1,.55l-84.94-49a2.21,2.21,0,0,1-1-1.71C345.65,189.37,346.1,189.13,346.66,189.45Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.66,193.83l84.94,49a2.19,2.19,0,0,1,1,1.7c0,.62-.45.86-1,.54l-84.94-49a2.17,2.17,0,0,1-1-1.7C345.65,193.75,346.1,193.5,346.66,193.83Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.66,198.2l84.94,49a2.21,2.21,0,0,1,1,1.71c0,.62-.45.86-1,.54l-84.94-49a2.19,2.19,0,0,1-1-1.71C345.65,198.12,346.1,197.88,346.66,198.2Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.08,181.54v8.22l-110.2-63.63v-8.21c0-1,.52-1.47,1.15-1.11l107.9,62.29A3.06,3.06,0,0,1,436.08,181.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.08,189.76v10l-110.2-63.62v-10l2.37,1.36c.64.37.85-.09,1.15-1.11l.81-2.64c.25-.95.51-1.48,1.15-1.1l27.51,15.88c.64.37,1.14,1,1.62,2.71l1,3.71c.36,1.33.54,2.06,1.18,2.42Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.61,180.28a3.26,3.26,0,0,1,1.23,2.61c0,1-.55,1.57-1.23,1.18a3.24,3.24,0,0,1-1.23-2.6C430.38,180.42,430.93,179.89,431.61,180.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.18,177.72a3.25,3.25,0,0,1,1.23,2.61c0,1-.55,1.57-1.23,1.18a3.24,3.24,0,0,1-1.23-2.6C426,177.86,426.5,177.33,427.18,177.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.75,175.16a3.25,3.25,0,0,1,1.23,2.61c0,1-.55,1.57-1.23,1.18a3.25,3.25,0,0,1-1.23-2.61C421.52,175.3,422.07,174.77,422.75,175.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.17,134l-1.81-1,.69-.84a.51.51,0,0,0,0-.41c-.06-.16-.15-.22-.21-.15l-1,1.2h0s0,0,0,.06,0,0,0,0a.37.37,0,0,0,0,.11.53.53,0,0,0,0,.13s0,0,0,0a.32.32,0,0,0,0,.09h0l1,2.33a.28.28,0,0,0,.1.13.08.08,0,0,0,.11,0,.59.59,0,0,0,0-.43l-.69-1.64,1.81,1c.08.05.15,0,.15-.21A.47.47,0,0,0,331.17,134Z",
    style: {
      fill: "#455a64",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.68,134.85l1.81,1-.69-1.63a.58.58,0,0,1,0-.43c0-.1.15-.05.21.09l1,2.33h0l0,.09v0a.69.69,0,0,1,0,.13.36.36,0,0,1,0,.11v0a.16.16,0,0,1,0,.06h0l-1,1.19a.07.07,0,0,1-.1,0,.3.3,0,0,1-.11-.16.54.54,0,0,1,0-.42l.69-.84-1.81-1a.5.5,0,0,1-.14-.39C332.54,134.9,332.6,134.8,332.68,134.85Z",
    style: {
      fill: "#455a64",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.62,135.9c0-.16-.1-.27-.15-.18l-.25.48c-.42-.63-.94-.77-1.28-.26a4.23,4.23,0,0,0,0,3.33,2.24,2.24,0,0,0,.81,1.16.56.56,0,0,0,.81-.22.51.51,0,0,0,0-.42c-.05-.15-.14-.2-.2-.12-.34.49-.88.18-1.22-.7a3.22,3.22,0,0,1,0-2.49c.24-.35.58-.29.88.09l-.18.36c0,.09,0,.3.07.33l.74.35c.05,0,.09,0,.08-.15Z",
    style: {
      fill: "#455a64",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.08,142l.66-1a.82.82,0,0,0,0-.58c-.08-.21-.21-.28-.29-.17l-.66,1-.66-1.74c-.07-.2-.2-.28-.28-.16a.72.72,0,0,0,0,.58l.66,1.73-.66,1a.72.72,0,0,0,0,.58.41.41,0,0,0,.14.2.1.1,0,0,0,.14,0l.66-1,.66,1.73a.41.41,0,0,0,.14.2.1.1,0,0,0,.15,0,.81.81,0,0,0,0-.58Z",
    style: {
      fill: "#455a64",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341,141.42v-3.11c0-1,.52-1.47,1.16-1.11l86.26,49.85a3,3,0,0,1,1.15,2.44v3.11c0,1-.51,1.48-1.15,1.11l-86.26-49.84A3.06,3.06,0,0,1,341,141.42Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.42,192.85a.51.51,0,0,1-.42-.25l-.5-.76-.58.21-.24-.15a.76.76,0,0,1-.26-.67l.12-1.13-.5-1.17a.71.71,0,0,1,.07-.74l.16-.18.3.06.39.12.22-.65a.46.46,0,0,1,.45-.34.58.58,0,0,1,.5.5l.31,1.27.65.55a.73.73,0,0,1,.24.52.57.57,0,0,1-.13.45l-.43.5.11,1.24a.53.53,0,0,1-.32.59A.32.32,0,0,1,428.42,192.85Zm-.7-1.09Zm-.11-.73a.5.5,0,0,1,.41.24l0,0,0-.27a.63.63,0,0,1,.12-.46l.42-.49-.63-.55a.79.79,0,0,1-.22-.39l-.12-.47v0a.47.47,0,0,1-.57.31l-.15-.05.35.81a.84.84,0,0,1,.06.41l-.1,1,.28-.1A.4.4,0,0,1,427.61,191Zm1-1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M431.05,190.24a2.31,2.31,0,0,1-.32-.69c-.1-.38,0-.6.14-.5l3,1.76a1.61,1.61,0,0,1,.51.87c.1.38,0,.6-.14.5l-3-1.76A.77.77,0,0,1,431.05,190.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.05,192.58a2.2,2.2,0,0,1-.32-.69c-.1-.38,0-.6.14-.5l3,1.76a1.66,1.66,0,0,1,.51.87c.1.38,0,.6-.14.5l-3-1.76A.77.77,0,0,1,431.05,192.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.05,194.92a2.14,2.14,0,0,1-.32-.68c-.1-.38,0-.61.14-.5l3,1.75a1.69,1.69,0,0,1,.51.88c.1.37,0,.6-.14.49l-3-1.75A.84.84,0,0,1,431.05,194.92Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M431.58,273.8l-110.79-64a3.41,3.41,0,0,0-3.11,0l-1.85,1a1,1,0,0,0,0,1.8l110.81,64a3.41,3.41,0,0,0,3.11,0l1.83-1A1,1,0,0,0,431.58,273.8Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.12,215,422.9,279c.86.5,1,1.23.27,1.64l-28.83,16.65a3.21,3.21,0,0,1-2.85-.15L280.86,233.21c-.86-.5-1-1.23-.28-1.65l28.7-16.71A3.12,3.12,0,0,1,312.12,215Z",
    style: {
      fill: "#263238",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.37,270.42l3.47,2a.55.55,0,0,0,.5,0l3.32-1.91c.13-.08.12-.21,0-.29l-3.47-2a.55.55,0,0,0-.5,0l-3.32,1.91C376.21,270.21,376.23,270.34,376.37,270.42Zm12-2.92-3.46-2a.54.54,0,0,0-.51,0l-3.32,1.91c-.13.08-.11.21,0,.3l3.47,2a.61.61,0,0,0,.51,0l3.31-1.92C388.53,267.71,388.52,267.58,388.37,267.5ZM377.17,261l-5.87-3.39a.57.57,0,0,0-.51,0l-3.31,1.92c-.14.07-.12.2,0,.29l5.87,3.39a.59.59,0,0,0,.5,0l3.32-1.92C377.33,261.24,377.32,261.11,377.17,261Zm6.14,3.54-3.47-2a.57.57,0,0,0-.51,0L376,264.47c-.13.07-.11.2,0,.29l3.47,2a.57.57,0,0,0,.51,0l3.31-1.92C383.47,264.79,383.45,264.66,383.31,264.57Zm-13.61-7.85-3.47-2a.57.57,0,0,0-.51,0l-3.31,1.91c-.14.08-.12.21,0,.29l3.46,2a.54.54,0,0,0,.51,0l3.32-1.91C369.86,256.93,369.84,256.8,369.7,256.72Zm-5.07-2.93-3.47-2a.54.54,0,0,0-.51,0l-3.31,1.91c-.14.08-.12.21,0,.3l3.46,2a.61.61,0,0,0,.51,0l3.32-1.92C364.79,254,364.77,253.87,364.63,253.79Zm-13.54,7.51,3.47,2a.55.55,0,0,0,.5,0l3.32-1.92c.13-.07.11-.2,0-.29l-3.47-2a.57.57,0,0,0-.51,0L351.06,261C350.93,261.08,350.94,261.21,351.09,261.3ZM346,258.37l3.47,2a.52.52,0,0,0,.5,0l3.32-1.91c.13-.08.12-.21,0-.3l-3.47-2a.59.59,0,0,0-.5,0L346,258.08C345.86,258.16,345.87,258.29,346,258.37ZM341,255.44l3.47,2a.55.55,0,0,0,.5,0l3.32-1.91c.13-.08.12-.21,0-.29l-3.47-2a.55.55,0,0,0-.5,0l-3.32,1.91C340.79,255.23,340.8,255.36,341,255.44Zm-5.07-2.92,3.47,2a.59.59,0,0,0,.5,0l3.32-1.92c.13-.07.12-.2,0-.29l-3.47-2a.52.52,0,0,0-.5,0l-3.32,1.92C335.72,252.3,335.73,252.43,335.88,252.52Zm35.42,15,3.47,2a.59.59,0,0,0,.5,0l3.32-1.92c.13-.08.12-.21,0-.29l-3.46-2a.54.54,0,0,0-.51,0l-3.32,1.91C371.14,267.28,371.16,267.41,371.3,267.5Zm-15.14-3.27,7.73,4.46a.54.54,0,0,0,.51,0l8.06-4.65c.13-.08.11-.21,0-.29l-4-2.31a.52.52,0,0,0-.5,0l-4.27,2.46a.52.52,0,0,1-.5,0L360,262a.54.54,0,0,0-.51,0l-3.31,1.91C356,264,356,264.14,356.16,264.23Zm3.4-13.37-3.47-2a.57.57,0,0,0-.51,0l-3.31,1.92c-.13.07-.12.2,0,.29l3.46,2a.57.57,0,0,0,.51,0l3.32-1.92C359.72,251.08,359.7,251,359.56,250.86Zm-5.07-2.93-3.47-2a.61.61,0,0,0-.51,0l-3.31,1.92c-.13.08-.12.21,0,.29l3.47,2a.52.52,0,0,0,.5,0l3.32-1.91C354.65,248.15,354.63,248,354.49,247.93Zm-54.13-16.19c-.13.07-.12.2,0,.29l3.47,2a.55.55,0,0,0,.5,0l3.32-1.92c.13-.07.12-.2,0-.29l-3.47-2a.55.55,0,0,0-.5,0Zm13.57-7.22-3.47-2a.52.52,0,0,0-.5,0l-3.32,1.91c-.13.08-.12.21,0,.3l3.47,2a.59.59,0,0,0,.5,0l3.32-1.92C314.09,224.73,314.08,224.6,313.93,224.52Zm-10.16,3.71c-.13.08-.12.21,0,.29l3.46,2a.54.54,0,0,0,.51,0l3.32-1.92c.13-.07.11-.2,0-.29l-3.47-2a.61.61,0,0,0-.51,0Zm-5.45,8.08,3.47,2a.59.59,0,0,0,.5,0l3.32-1.92c.13-.08.12-.21,0-.29l-3.47-2a.52.52,0,0,0-.5,0L298.29,236C298.16,236.09,298.17,236.22,298.32,236.31Zm-5.1-3.22c-.13.07-.12.2,0,.29l3.47,2a.55.55,0,0,0,.5,0l3.32-1.92c.13-.07.12-.2,0-.29l-3.47-2a.55.55,0,0,0-.5,0ZM319,227.45l-3.47-2a.55.55,0,0,0-.5,0l-3.32,1.91c-.13.08-.12.21,0,.29l3.47,2a.55.55,0,0,0,.5,0l3.32-1.91C319.16,227.66,319.15,227.53,319,227.45Zm25.35,14.63-3.47-2a.52.52,0,0,0-.5,0L337.06,242c-.13.07-.12.2,0,.29l3.47,2a.55.55,0,0,0,.5,0l3.32-1.92C344.51,242.3,344.5,242.17,344.35,242.08Zm-20.28-11.71-3.47-2a.55.55,0,0,0-.5,0l-3.32,1.92c-.13.07-.12.2,0,.29l3.47,2a.55.55,0,0,0,.5,0l3.32-1.92C324.23,230.59,324.22,230.46,324.07,230.37ZM349.42,245,346,243a.55.55,0,0,0-.5,0l-3.32,1.91c-.13.08-.12.21,0,.29l3.47,2a.55.55,0,0,0,.5,0l3.32-1.91C349.58,245.22,349.57,245.09,349.42,245Zm-10.14-5.86-3.47-2a.59.59,0,0,0-.5,0L332,239.05c-.13.08-.12.21,0,.29l3.47,2a.52.52,0,0,0,.5,0l3.32-1.92C339.44,239.37,339.43,239.24,339.28,239.15Zm-5.07-2.92-3.47-2a.55.55,0,0,0-.5,0l-3.32,1.91c-.13.08-.12.21,0,.29l3.47,2a.55.55,0,0,0,.5,0l3.32-1.91C334.37,236.44,334.36,236.31,334.21,236.23Zm-5.07-2.93-3.47-2a.52.52,0,0,0-.5,0l-3.32,1.92c-.13.07-.12.2,0,.29l3.47,2a.59.59,0,0,0,.5,0l3.32-1.92C329.3,233.51,329.29,233.38,329.14,233.3Zm-3.4,13.36,3.47,2a.55.55,0,0,0,.5,0l3.32-1.91c.13-.08.12-.21,0-.29l-3.47-2a.55.55,0,0,0-.5,0l-3.32,1.91C325.58,246.45,325.59,246.58,325.74,246.66ZM399.58,274l-3.47-2a.52.52,0,0,0-.5,0l-3.32,1.92c-.13.07-.12.2,0,.29l3.47,2a.59.59,0,0,0,.5,0l3.32-1.92C399.74,274.18,399.73,274.05,399.58,274Zm-6.14-3.54-3.46-2a.57.57,0,0,0-.51,0l-3.32,1.91c-.13.08-.11.21,0,.29l3.47,2a.57.57,0,0,0,.51,0l3.31-1.91C393.6,270.64,393.59,270.51,393.44,270.43Zm11.21,6.47-3.47-2a.55.55,0,0,0-.5,0l-3.32,1.91c-.13.08-.12.21,0,.29l3.47,2a.55.55,0,0,0,.5,0l3.32-1.91C404.81,277.11,404.8,277,404.65,276.9Zm-45.09-16.18,3.47,2a.55.55,0,0,0,.5,0l3.32-1.92c.13-.07.12-.2,0-.29l-3.47-2a.55.55,0,0,0-.5,0l-3.32,1.92C359.4,260.5,359.42,260.63,359.56,260.72Zm50.19,19.39c.13-.07.12-.2,0-.29l-3.47-2a.59.59,0,0,0-.5,0l-3.32,1.92c-.13.07-.12.2,0,.29l3.47,2a.52.52,0,0,0,.5,0Zm-78.94-30.52,3.47,2a.52.52,0,0,0,.5,0l3.32-1.92c.13-.07.12-.2,0-.29l-3.47-2a.59.59,0,0,0-.5,0l-3.32,1.92C330.65,249.37,330.66,249.51,330.81,249.59ZM393,285.48l3.47,2a.55.55,0,0,0,.5,0l3.32-1.91c.13-.08.12-.21,0-.29l-3.47-2a.55.55,0,0,0-.5,0L393,285.19C392.82,285.27,392.83,285.4,393,285.48Zm-.33-5.66,3.47,2a.52.52,0,0,0,.5,0l3.32-1.92c.13-.07.12-.2,0-.29l-3.47-2a.59.59,0,0,0-.5,0l-3.32,1.92C392.49,279.6,392.5,279.73,392.65,279.82Zm12.36,3c.13-.07.12-.21,0-.29l-3.47-2a.52.52,0,0,0-.5,0l-3.32,1.92c-.13.07-.12.2,0,.29l3.47,2a.59.59,0,0,0,.5,0Zm1.07.62L398,288.12c-.13.08-.12.21,0,.29l3.47,2a.52.52,0,0,0,.5,0l8.06-4.65c.13-.08.12-.21,0-.29l-3.47-2A.55.55,0,0,0,406.08,283.47Zm-11.24-6.76-3.47-2a.55.55,0,0,0-.5,0l-3.32,1.91c-.13.08-.12.21,0,.29l3.47,2a.55.55,0,0,0,.5,0l3.32-1.91C395,276.92,395,276.79,394.84,276.71Zm-38.16-22-3.46-2a.57.57,0,0,0-.51,0l-3.32,1.91c-.13.08-.11.21,0,.29l3.47,2a.57.57,0,0,0,.51,0l3.31-1.91C356.85,254.89,356.83,254.76,356.68,254.68Zm31.2,27.59c-.13.07-.12.2,0,.29l3.47,2a.59.59,0,0,0,.5,0l3.32-1.92c.13-.07.12-.2,0-.29l-3.47-2a.52.52,0,0,0-.5,0ZM361.75,257.6l-3.46-2a.61.61,0,0,0-.51,0l-3.32,1.92c-.13.08-.11.21,0,.29l3.47,2a.54.54,0,0,0,.51,0l3.31-1.92C361.91,257.82,361.9,257.69,361.75,257.6Zm-56.32-22.94c-.13.08-.12.21,0,.3l3.47,2a.59.59,0,0,0,.5,0l3.32-1.92c.13-.08.12-.21,0-.29l-3.47-2a.52.52,0,0,0-.5,0Zm10.7-3.4-3.47-2a.57.57,0,0,0-.51,0l-3.31,1.92c-.13.07-.12.2,0,.29l3.46,2a.57.57,0,0,0,.51,0l3.32-1.92C316.29,231.48,316.27,231.35,316.13,231.26Zm-5.6,6.62,3.47,2a.52.52,0,0,0,.5,0l3.32-1.91c.13-.08.12-.21,0-.29l-3.47-2a.55.55,0,0,0-.5,0l-3.32,1.91C310.37,237.67,310.38,237.8,310.53,237.88Zm5.07,2.93,3.47,2a.55.55,0,0,0,.5,0l3.32-1.92c.13-.07.12-.2,0-.29l-3.47-2a.55.55,0,0,0-.5,0l-3.32,1.92C315.44,240.59,315.45,240.72,315.6,240.81Zm5.07,2.93,3.47,2a.59.59,0,0,0,.5,0l3.32-1.92c.13-.08.12-.21,0-.29l-3.47-2a.52.52,0,0,0-.5,0l-3.32,1.92C320.51,243.52,320.52,243.65,320.67,243.74Zm.53-9.55-3.47-2a.54.54,0,0,0-.51,0l-3.31,1.91c-.14.08-.12.21,0,.3l3.46,2a.57.57,0,0,0,.51,0l3.32-1.91C321.36,234.4,321.34,234.27,321.2,234.19Zm5.07,2.92-3.47-2a.57.57,0,0,0-.51,0L319,237c-.14.08-.12.21,0,.29l3.46,2a.54.54,0,0,0,.51,0l3.32-1.91C326.43,237.33,326.41,237.2,326.27,237.11Zm20.27,11.71-3.46-2a.57.57,0,0,0-.51,0l-3.32,1.92c-.13.07-.11.2,0,.29l3.47,2a.54.54,0,0,0,.51,0l3.31-1.92C346.71,249,346.69,248.91,346.54,248.82Zm-5.06-2.92-3.47-2a.57.57,0,0,0-.51,0l-3.32,1.91c-.13.08-.11.21,0,.29l3.47,2a.57.57,0,0,0,.51,0l3.32-1.91C341.64,246.11,341.62,246,341.48,245.9Zm10.13,5.85-3.46-2a.54.54,0,0,0-.51,0l-3.32,1.92c-.13.07-.11.2,0,.29l3.47,2a.61.61,0,0,0,.51,0l3.31-1.92C351.78,252,351.76,251.83,351.61,251.75ZM331.34,240l-3.47-2a.57.57,0,0,0-.51,0l-3.31,1.92c-.14.07-.12.2,0,.29l3.47,2a.57.57,0,0,0,.51,0l3.32-1.92C331.5,240.26,331.48,240.13,331.34,240Zm5.07,2.93-3.47-2a.54.54,0,0,0-.51,0l-3.32,1.91c-.13.08-.11.21,0,.3l3.47,2a.61.61,0,0,0,.51,0l3.32-1.92C336.57,243.18,336.55,243.05,336.41,243Zm-33-3.74,3.47,2a.55.55,0,0,0,.5,0l3.32-1.91c.13-.08.12-.21,0-.29l-3.47-2a.55.55,0,0,0-.5,0l-3.32,1.91C303.23,239,303.24,239.15,303.39,239.23Zm2.18-15.43,3.32-1.92c.13-.07.12-.2,0-.29l-3.47-2a.55.55,0,0,0-.5,0l-3.32,1.92c-.13.07-.12.2,0,.29l3.47,2A.55.55,0,0,0,305.57,223.8Zm-2.87,3.81L306,225.7c.13-.08.12-.21,0-.29l-5.34-3.08a.52.52,0,0,0-.5,0l-3.32,1.91c-.13.08-.12.21,0,.3l5.34,3.08A.55.55,0,0,0,302.7,227.61Zm9.43-6.67,3.31-1.92c.14-.07.12-.2,0-.29l-4.26-2.46a.54.54,0,0,0-.51,0l-3.32,1.92c-.13.07-.11.2,0,.29l4.27,2.46A.57.57,0,0,0,312.13,220.94Zm3.27,1.89c-.13.07-.12.2,0,.29l3.47,2a.55.55,0,0,0,.5,0l3.32-1.92c.13-.07.12-.2,0-.29l-3.47-2a.55.55,0,0,0-.5,0Zm-16.11,8.29,3.32-1.91c.13-.08.12-.21,0-.3l-6.67-3.85a.55.55,0,0,0-.5,0L292.09,227c-.13.08-.12.21,0,.29l6.67,3.85A.52.52,0,0,0,299.29,231.12Zm-7.14,1.35,3.32-1.91c.13-.08.12-.21,0-.29l-4.27-2.47a.59.59,0,0,0-.5,0l-3.32,1.92c-.13.07-.12.2,0,.29l4.27,2.46A.52.52,0,0,0,292.15,232.47Zm60.94,12.12c-.13.08-.12.21,0,.29l3.47,2a.52.52,0,0,0,.5,0l3.32-1.91c.13-.08.12-.21,0-.3l-3.46-2a.61.61,0,0,0-.51,0ZM343,238.74c-.13.07-.11.2,0,.29l3.47,2a.57.57,0,0,0,.51,0l3.31-1.92c.14-.07.12-.2,0-.29l-3.46-2a.57.57,0,0,0-.51,0Zm-22.48-13c-.13.07-.12.2,0,.29l3.47,2a.59.59,0,0,0,.5,0l3.32-1.92c.13-.08.12-.21,0-.29l-3.47-2a.52.52,0,0,0-.5,0ZM348,241.66c-.13.08-.11.21,0,.29l3.47,2a.57.57,0,0,0,.51,0l3.31-1.91c.13-.08.12-.21,0-.29l-3.46-2a.54.54,0,0,0-.51,0Zm-10.14-5.85c-.13.08-.11.21,0,.29l3.47,2a.54.54,0,0,0,.51,0l3.31-1.92c.14-.07.12-.2,0-.29l-3.46-2a.61.61,0,0,0-.51,0Zm-46.08-1.9c.13-.08.11-.21,0-.29l-5.34-3.08a.52.52,0,0,0-.5,0l-3.32,1.92c-.13.07-.12.2,0,.29l5.33,3.08a.57.57,0,0,0,.51,0Zm38.81-2.3c-.13.08-.12.21,0,.29l3.47,2a.52.52,0,0,0,.5,0l3.32-1.92c.13-.07.12-.2,0-.29l-3.47-2a.59.59,0,0,0-.5,0Zm-5.07-2.93c-.13.08-.12.21,0,.29l3.47,2a.55.55,0,0,0,.5,0l3.32-1.91c.13-.08.12-.21,0-.29l-3.47-2a.55.55,0,0,0-.5,0Zm60.18,59.46c.13-.08.11-.21,0-.3l-8.54-4.93a.55.55,0,0,0-.5,0l-3.32,1.91c-.13.08-.12.21,0,.29L381.9,290a.52.52,0,0,0,.5,0Zm-11.21-6.48c.13-.07.12-.2,0-.29l-3.47-2a.59.59,0,0,0-.5,0l-3.32,1.92c-.13.08-.12.21,0,.29l3.47,2a.52.52,0,0,0,.5,0Zm-66.05-39.5,3.46,2a.54.54,0,0,0,.51,0l3.32-1.92c.13-.07.11-.2,0-.29l-3.47-2a.59.59,0,0,0-.5,0l-3.32,1.92C308.3,241.94,308.31,242.07,308.46,242.16Zm55.91,33.65c.13-.07.12-.2,0-.29l-3.47-2a.52.52,0,0,0-.5,0l-3.32,1.92c-.13.07-.12.2,0,.29l3.47,2a.59.59,0,0,0,.5,0Zm26.42,15.25c.13-.07.11-.2,0-.29l-3.47-2a.55.55,0,0,0-.5,0l-3.32,1.92c-.13.07-.12.2,0,.29l3.46,2a.57.57,0,0,0,.51,0Zm1.75,4.84,8.06-4.65c.13-.07.12-.2,0-.29l-3.47-2a.55.55,0,0,0-.5,0l-8.06,4.65c-.14.08-.12.21,0,.3l3.46,2A.57.57,0,0,0,392.54,295.9Zm-47.11-31c.13-.07.11-.2,0-.29l-4.27-2.46a.54.54,0,0,0-.51,0L337.31,264c-.14.07-.12.2,0,.29l4.26,2.46a.57.57,0,0,0,.51,0Zm12.8,7.4c.14-.08.12-.21,0-.29l-5.33-3.08a.54.54,0,0,0-.51,0l-3.31,1.91c-.14.08-.12.21,0,.3l5.33,3.08a.57.57,0,0,0,.51,0ZM333.69,258.1c.13-.08.11-.21,0-.3l-28.55-16.48a.61.61,0,0,0-.51,0l-3.32,1.92c-.13.08-.11.21,0,.29L329.86,260a.54.54,0,0,0,.51,0Zm-30.15-17.41c.13-.08.11-.21,0-.29l-4.27-2.47a.61.61,0,0,0-.51,0l-3.32,1.92c-.13.08-.11.21,0,.29l4.27,2.47a.57.57,0,0,0,.51,0Zm36,20.79c.13-.07.11-.2,0-.29l-4.27-2.46a.57.57,0,0,0-.51,0l-3.31,1.92c-.14.07-.12.2,0,.29l4.26,2.46a.54.54,0,0,0,.51,0ZM297.67,237.3c.13-.08.11-.21,0-.29l-4.27-2.47a.57.57,0,0,0-.51,0l-3.32,1.91c-.13.08-.11.21,0,.29l4.27,2.47a.57.57,0,0,0,.51,0Zm53.63,31c.13-.07.12-.2,0-.29L347,265.51a.54.54,0,0,0-.51,0l-3.31,1.92c-.14.07-.12.2,0,.29l4.26,2.46a.57.57,0,0,0,.51,0Zm18.14,10.48c.13-.08.12-.21,0-.29l-3.47-2a.55.55,0,0,0-.5,0l-3.32,1.91c-.13.08-.12.21,0,.29l3.47,2a.55.55,0,0,0,.5,0Zm13.73,6.55,3.47,2a.55.55,0,0,0,.5,0l3.32-1.91c.13-.08.12-.21,0-.29l-3.47-2a.55.55,0,0,0-.5,0L383.14,285C383,285.08,383,285.21,383.17,285.29Zm-1.73-11.94,3.47,2a.52.52,0,0,0,.5,0l3.32-1.92c.13-.07.12-.2,0-.29l-3.47-2a.55.55,0,0,0-.5,0l-3.32,1.92C381.28,273.13,381.29,273.26,381.44,273.35ZM349,265.58l10.14,5.85a.61.61,0,0,0,.51,0l3.32-1.92c.13-.07.11-.21,0-.29l-10.14-5.85a.54.54,0,0,0-.51,0L349,265.28C348.85,265.36,348.87,265.49,349,265.58Zm29.06,16.5c-.13.07-.12.2,0,.29l3.47,2a.59.59,0,0,0,.5,0l3.32-1.92c.13-.07.12-.2,0-.29l-3.47-2a.52.52,0,0,0-.5,0Zm4.77-2.45,3.47,2a.52.52,0,0,0,.5,0l3.32-1.92c.13-.07.12-.2,0-.29l-3.47-2a.59.59,0,0,0-.5,0l-3.32,1.92C382.68,279.41,382.69,279.55,382.84,279.63Zm-38.9-17,3.47,2a.57.57,0,0,0,.51,0l3.32-1.92c.13-.07.11-.2,0-.29l-3.47-2a.57.57,0,0,0-.51,0l-3.32,1.92C343.78,262.43,343.8,262.56,343.94,262.65Zm22.92,13c-.13.07-.12.2,0,.29l3.47,2a.59.59,0,0,0,.5,0l3.32-1.92c.13-.07.12-.2,0-.29l-3.47-2a.52.52,0,0,0-.5,0ZM318.6,248l3.46,2a.57.57,0,0,0,.51,0l3.32-1.91c.13-.08.11-.21,0-.29l-3.47-2a.57.57,0,0,0-.51,0l-3.31,1.91C318.43,247.8,318.45,247.93,318.6,248Zm5.07,2.93,3.46,2a.54.54,0,0,0,.51,0L331,251c.13-.07.11-.2,0-.29l-3.47-2a.61.61,0,0,0-.51,0l-3.31,1.92C323.5,250.73,323.52,250.86,323.67,250.94Zm-10.14-5.85,3.46,2a.61.61,0,0,0,.51,0l3.32-1.92c.13-.07.11-.21,0-.29l-3.47-2a.54.54,0,0,0-.51,0l-3.31,1.92C313.37,244.87,313.38,245,313.53,245.09Zm20.27,11.7,3.47,2a.57.57,0,0,0,.51,0l3.32-1.91c.13-.08.11-.21,0-.29l-3.47-2a.57.57,0,0,0-.51,0l-3.32,1.91C333.64,256.58,333.66,256.71,333.8,256.79Zm-5.06-2.92,3.46,2a.57.57,0,0,0,.51,0L336,254c.13-.07.11-.2,0-.29l-3.47-2a.57.57,0,0,0-.51,0l-3.31,1.92C328.57,253.65,328.59,253.78,328.74,253.87Zm10.13,5.85,3.47,2a.54.54,0,0,0,.51,0l3.32-1.91c.13-.08.11-.21,0-.3l-3.47-2a.61.61,0,0,0-.51,0l-3.32,1.92C338.71,259.51,338.73,259.64,338.87,259.72Zm70.53,16c-.13.08-.12.21,0,.3l3.47,2a.55.55,0,0,0,.5,0l.89-.51c.13-.07.11-.2,0-.29l-3.47-2a.61.61,0,0,0-.51,0Zm-27.63-14.54c-.13.07-.12.2,0,.29l3.47,2a.59.59,0,0,0,.5,0l3.32-1.92c.13-.07.12-.2,0-.29l-3.47-2a.52.52,0,0,0-.5,0ZM391.91,267c-.13.08-.12.21,0,.29l3.46,2a.54.54,0,0,0,.51,0l3.32-1.92c.13-.07.11-.2,0-.29l-3.47-2a.59.59,0,0,0-.5,0Zm-16.33-9.43c-.13.08-.12.21,0,.29l3.47,2a.55.55,0,0,0,.5,0L382.9,258c.13-.08.12-.21,0-.29l-3.47-2a.55.55,0,0,0-.5,0Zm11.26,6.5c-.13.08-.12.21,0,.29l3.47,2a.55.55,0,0,0,.5,0l3.32-1.91c.13-.08.12-.21,0-.29l-3.47-2a.55.55,0,0,0-.5,0Zm-21.4-12.35c-.13.07-.12.2,0,.29l3.47,2a.55.55,0,0,0,.5,0l3.32-1.92c.13-.07.12-.2,0-.29l-3.47-2a.55.55,0,0,0-.5,0Zm5.07,2.93c-.13.07-.12.2,0,.29l3.47,2a.59.59,0,0,0,.5,0l3.32-1.92c.13-.08.12-.21,0-.29l-3.47-2a.52.52,0,0,0-.5,0Zm28.75,15.19c-.13.08-.12.21,0,.29l3.47,2a.52.52,0,0,0,.5,0l.89-.51c.13-.07.11-.2,0-.29l-3.47-2a.54.54,0,0,0-.51,0Zm15.21,8.78c-.13.08-.12.21,0,.29l3.47,2a.52.52,0,0,0,.5,0l.89-.51c.13-.07.11-.2,0-.29l-3.47-2a.57.57,0,0,0-.51,0Zm-7,4c-.13.07-.12.2,0,.29l3.47,2a.59.59,0,0,0,.5,0l3.32-1.92c.13-.07.12-.21,0-.29l-3.47-2a.52.52,0,0,0-.5,0Zm-19.26,5.57,3.47,2a.52.52,0,0,0,.5,0l3.32-1.92c.13-.07.12-.2,0-.29L392,286a.59.59,0,0,0-.5,0l-3.32,1.92C388.08,288,388.09,288.14,388.24,288.22Zm16.09-15.45c-.13.07-.12.2,0,.29l3.47,2a.55.55,0,0,0,.5,0l.89-.51c.13-.08.11-.21,0-.29l-3.47-2a.57.57,0,0,0-.51,0Zm-44-24c-.13.08-.12.21,0,.29l3.47,2a.52.52,0,0,0,.5,0l3.32-1.91c.13-.08.12-.21,0-.29l-3.47-2a.55.55,0,0,0-.5,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.36 277.26 348.64 277.67 329.75 288.57 296.16 269.18 295.46 268.78 315.06 257.46 349.36 277.26",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.64 277.67 329.75 288.57 296.16 269.18 315.06 258.27 348.64 277.67",
    style: {
      fill: "#00A6C3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.64 277.67 329.75 288.57 296.16 269.18 315.06 258.27 348.64 277.67",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.78,274l0,0,0,0Z",
    style: {
      fill: "#00A6C3"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-1--inject-148"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.9,190.13l-7.6,10.37-3.91,4,1.35,2.5c.66,1.36,2.67,3.33,5,.79,3.44-3.72,8.86-15.91,8.86-15.91Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.36,183.58c2.41,5.76,7.08,17.81,7.08,17.81l-4.7,5.58s-1.13-2-2.61-5c-1.91-3.84-3.94-8.06-3.94-8.06l-3.77-16.77C269.41,177.39,272.26,178.55,274.36,183.58Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.89,183.5c1-1.84,1.23-1.92,1.82-2.32s4.2-1,5.7-1.07c1.76-.15,2.38.17,1.89,1.69a76.38,76.38,0,0,1-4.94,11.08c-.46.62-.56,1.2-2.54,1.39s-4.17.29-4.86.33-1.63.21-1-1.8a65,65,0,0,1,2.7-6.68C283.41,184.46,283.89,183.5,283.89,183.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.62,191.85c.74-3.25,2.9-6.26,1.68-7.36l-.66,1.44a28,28,0,0,1-6,.82c-2-.15-3.56-.61-4.1-.23-1.13.8-1.46,4.21,1.8,5.44C286.1,193,290.62,191.85,290.62,191.85Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.31,177c3.95,0,4.68.81,6,2.21,2.32,2.54,6.29,14.11,6.29,14.11a9.56,9.56,0,0,1-8.37,4.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.75,290.07v-.79c.31.93,1.75,4.9,3.93,6.89,1.74,1.58,4.1,3.41,4.71,5.17s-3.3,2.46-4.92,2.17a10,10,0,0,1-5.65-3c-.93-1.15-1.52-2.51-2.19-3.41s-2.2-1.9-2.56-2.95a6.61,6.61,0,0,1,.32-2.89c.25-1,.53-2,.86-2v.6a4.25,4.25,0,0,0,2.75.93C271.8,290.84,273.76,290.68,273.75,290.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.83,292.24a27.31,27.31,0,0,0-.43,4.45c-.05,2.7-.54,3.65-.61,5.87a8.27,8.27,0,0,0,1.49,5.53c1,1.42,3.95,2.17,5.09-.23s1-4,.63-6.47-.42-4-.64-5.94c-.19-1.73-.42-3-.42-3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.69,261.45c.63-6.51,2.32-9.42,2.45-10.9,0,0-2.61-28.54.11-40.47h24.26c.73,10.57,4.47,31.54,3.53,40.85-.54,5.41-3.29,34.81-3.29,34.81v2.17a7.58,7.58,0,0,0,.58,2.9,16,16,0,0,0,3.35,5.35c.49.45,1,.92,1.57,1.4,1.35,1.57.29,2.22-1.78,1.95a8,8,0,0,1-5-3.31c-1.43-2-4-5-4.22-6.17h0v-.14h0v-3.81c-.09-3.63-3.69-23.09-3.26-27.58a39.92,39.92,0,0,1,1.46-6.59l-3.86-22.77s-2.35,16.13-3.19,22.8c-1,7.65-6.31,37.85-6.32,37.89a24.41,24.41,0,0,0-.14,2.59c0,.86.48,8.37.27,10.31-.3,2.85-4.42,3.07-5-.18-.4-2.15-.34-9.25-.37-10.3,0-.76-.06-1.6-.1-2.5C247.67,289.19,246,269,246.69,261.45Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.92,177.76l-2.47.45c1.38,6.72-4.25,14.24-4.25,14.24l4.2,9.44c-.4.72-3.62,5.39-5,9.7a92.48,92.48,0,0,0-4,23.84c6.36,7.62,28.83,7.31,34.8-1.38,0,0-2.26-18.26-7.75-32.38l1.12-6.47c3.33-3.95,1.91-7.24.89-9.2a30.22,30.22,0,0,0-6.66-9l-3-.1Z",
    style: {
      fill: "#00A6C3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.92,177.76l-2.47.45c1.38,6.72-4.25,14.24-4.25,14.24l4.2,9.44c-.4.72-3.62,5.39-5,9.7a92.48,92.48,0,0,0-4,23.84c6.36,7.62,28.83,7.31,34.8-1.38,0,0-2.26-18.26-7.75-32.38l1.12-6.47c3.33-3.95,1.91-7.24.89-9.2a30.22,30.22,0,0,0-6.66-9l-3-.1Z",
    style: {
      fill: "#00A6C3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.92,177.76l-2.47.45c1.38,6.72-4.25,14.24-4.25,14.24l4.2,9.44c-.4.72-3.62,5.39-5,9.7a92.48,92.48,0,0,0-4,23.84c6.36,7.62,28.83,7.31,34.8-1.38,0,0-2.26-18.26-7.75-32.38l1.12-6.47c3.33-3.95,1.91-7.24.89-9.2a30.22,30.22,0,0,0-6.66-9l-3-.1Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.67,194.47c-.56,2.44.94,5.37,2.57,6.94s-1.25,2.18-3.23,5.85-8.37,20.88-2.26,27.65,22.46,3.67,22.52,3.66c-9.08,3.92-23.85,2.81-28.82-3.14a92.48,92.48,0,0,1,4-23.84c1.38-4.31,4.6-9,5-9.7l-4.2-9.44a27.3,27.3,0,0,0,3.67-7.28l1.74.19A85,85,0,0,1,253.67,194.47Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.2,148.86a12.08,12.08,0,0,0-9.47-4.42,12.59,12.59,0,0,0-12.15,13v.37A11.29,11.29,0,0,0,253,168.4c.59,1.2,1.75,3.23,2.83,3.42v-1.64a10.88,10.88,0,0,0,5,1.21h2a10.93,10.93,0,0,0,10.93-10.93v-.71A12.44,12.44,0,0,0,267.2,148.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.88,150.33c-4,3.27-3.53,9.13-3.53,9.13.74-4.88,4-8.73,7.71-10.07s6.05-.57,6.13-.54C266.39,147.89,261.85,146.33,256.88,150.33Z",
    style: {
      fill: "#00A6C3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.78,154.58c1.26,1.15,2.84,3.67,2.72,11-.11,6.22-2,7.77-3,8.22s-2.85.19-4.68-.12v3.2s3.19,3.2,3,4.92-4.27,2.51-6.63.85a19.83,19.83,0,0,1-4.3-4.58l-.08-8.93s-1.07,1.09-2.9-.55c-1.51-1.36-2-3.67-.86-4.91a2.56,2.56,0,0,1,4.17.84,18.7,18.7,0,0,0,7.56-2.27A10,10,0,0,0,268.78,154.58Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.69,163.59a.75.75,0,0,0,.71.81.77.77,0,0,0,.79-.74.75.75,0,1,0-1.5-.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.31,163.76a.77.77,0,0,0,.71.82.78.78,0,0,0,.79-.75.75.75,0,1,0-1.5-.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.3,169.54l1.75.57a.91.91,0,0,1-1.14.66A1,1,0,0,1,264.3,169.54Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.72,161.44l-1.53-1.09a.87.87,0,0,1,1.26-.28A1.06,1.06,0,0,1,270.72,161.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.26,163.8l0,2.63a1.24,1.24,0,0,0,1.29-1.26A1.36,1.36,0,0,0,256.26,163.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.33 163.02 266.31 168.12 268.69 167.34 266.33 163.02",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.81,173.7c-1.92-.25-5.89-1.41-6.51-3a4.21,4.21,0,0,0,1.39,2.07c1.19,1.05,5.11,2.23,5.11,2.23Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.2,209c-.34-1.64,3.33-17.93,4.77-23.08l6.38,7.45-3.93,16.08a91.38,91.38,0,0,0,3.21,13.27,2.93,2.93,0,0,0,1.38,1.56,16.78,16.78,0,0,1,3.74,3.11c1,.94,1.86,1.14,1.76,1.46a1.59,1.59,0,0,1-2,.86,10.81,10.81,0,0,1-2.39-1.1,14.48,14.48,0,0,0,2.64,3.91c2.47,2.65,2.69,4.36-1.92,4.71-2.89.22-5.32-1.4-7.92-7.63-.75-1.79-1.7-4.4-2.41-6.75C242.86,217.27,242,212.8,241.2,209Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.51,188.69c1.74-4,.88-8.67-1-10.48-4.9.84-6.16,3.15-7.49,7.71-1.12,3.86-2.29,8.23-2.29,8.23,1.23,1.63,6.2,3.55,8.49,2.86Z",
    style: {
      fill: "#455a64"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResponsive);
export default __webpack_public_path__ + "static/media/responsive.d241fa83fa1ac20298ca426c579fc6eb.svg";
export { ForwardRef as ReactComponent };